// Copyright: IQGeo Limited 2010-2022
import $ from 'jquery';
import myw from 'myWorld/base/core';
import loginPage from 'myWorld/base/login';

$(() => {
    const languages = $('body').data('myw-languages').split(',');
    myw.localisation.init(['myw.client'], { languages });
    const loginInfo = JSON.parse(unescape($('body').data('myw-login-info')));

    myw.app = loginPage; //for debugging purposes
    loginPage.init(loginInfo);
});
